// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__\\+yrhg{
    position:absolute;
    /* top:calc( 50% - 150px);
    left:calc(50% - 150px); */
    min-width:100px;
    /* min-height:100px; */
    height:auto;
    padding:10px;
    text-align:left;

}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SelectedMessage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB;6BACyB;IACzB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;;AAEnB","sourcesContent":[".container{\n    position:absolute;\n    /* top:calc( 50% - 150px);\n    left:calc(50% - 150px); */\n    min-width:100px;\n    /* min-height:100px; */\n    height:auto;\n    padding:10px;\n    text-align:left;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__+yrhg`
};
export default ___CSS_LOADER_EXPORT___;
